<template lang="pug">
.v-terms-box.terms-box(v-if="data" :class="data.className")
	.terms-box__title(v-if="data.title") {{data.title}}
	.terms-box__items(v-if="data.items && data.items.length")
		.terms-box__item(v-for="(term, index) in data.items" :key="index")
			.terms-box__value {{term.value}}
			.terms-box__price(v-if="term.price")
				span.terms-box__dash -
				span.terms-box__currency(v-if="term.currency" ) {{term.currency}}
				|{{term.price}}
	.terms-box__text(v-if="data.text") {{data.text}}
</template>

<script>

import sourceMixin from "components/mixins/v-mixin-source.vue";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
};
</script>